import * as React from 'react';
export const IcFort = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 10h-.21a4.32 4.32 0 00-.16-3.21C17.94 5.4 16.45 4.47 14.2 4a5.15 5.15 0 01-1.6-.82l-.09-.05a.18.18 0 01-.07 0h-.54a.701.701 0 00-.14 0h-.13l-.08.05h-.09A4.55 4.55 0 019.81 4c-2.24.42-3.74 1.34-4.43 2.72A4.36 4.36 0 005.21 10H5a2 2 0 00-2 2v7a2 2 0 002 2h5v-4a2 2 0 114 0v4h5a2 2 0 002-2v-7a2 2 0 00-2-2z'
      fill='currentColor'
    />
  </svg>
);
